"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const { Fragment } = React;
const moment = require("moment");
const colors_1 = require("../styles/colors");
const Icons_1 = require("./Icons");
const renderLockScreen = (device) => {
    const currTime = moment().format('H:mm');
    let leftStyle;
    if (currTime.length === 4) {
        if (device !== 'Mobile') {
            leftStyle = 109;
        }
        else {
            leftStyle = 85;
        }
    }
    else {
        if (device !== 'Mobile') {
            leftStyle = 72;
        }
        else {
            leftStyle = 53;
        }
    }
    if (device === 'Mobile') {
        return (React.createElement(Fragment, null,
            React.createElement("div", { style: {
                    position: 'absolute',
                    top: 70.55,
                    left: leftStyle,
                    fontFamily: 'HelveticaNeue-Thin, Helvetica Neue',
                    fontSize: 87,
                    fontWeight: 300,
                    color: colors_1.silver,
                    zIndex: 10,
                } }, currTime),
            React.createElement("div", { style: {
                    position: 'absolute',
                    top: 166.548,
                    fontFamily: 'HelveticaNeue-Thin, Helvetica Neue',
                    fontSize: 22,
                    fontWeight: 200,
                    color: colors_1.silver,
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                    zIndex: 10,
                } }, moment().format('dddd, MMMM D'))));
    }
    return (React.createElement(Fragment, null,
        React.createElement("div", { style: {
                position: 'absolute',
                top: 160,
                left: leftStyle,
                fontFamily: 'HelveticaNeue-Thin, Helvetica Neue',
                fontSize: 87,
                fontWeight: 300,
                color: colors_1.silver,
                zIndex: 10,
            } }, currTime),
        React.createElement("div", { style: {
                position: 'absolute',
                top: 256,
                fontFamily: 'HelveticaNeue-Thin, Helvetica Neue',
                fontSize: 22,
                fontWeight: 200,
                color: colors_1.silver,
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                zIndex: 10,
            } }, moment().format('dddd, MMMM D'))));
};
const PhoneComponent = ({ children, device, viewLockScreen }) => {
    if (device === 'Mobile') {
        return (React.createElement("div", { style: {
                padding: 2,
                border: `1px solid ${colors_1.titanium}`,
                borderRadius: 11,
                height: 575,
                width: 326,
                position: 'relative',
                marginTop: 24,
            } },
            React.createElement("div", { style: {
                    borderRadius: 8,
                    border: '1px solid transparent',
                    overflow: 'hidden',
                    height: 568,
                    width: 320,
                    position: 'fixed',
                } }, children),
            viewLockScreen && renderLockScreen(device)));
    }
    return (React.createElement("div", { style: { position: 'relative', width: 368, height: 755 } },
        React.createElement(Icons_1.Phone, { fill: device === 'Tablet' ? colors_1.almostWhite : colors_1.white }),
        React.createElement("div", { style: {
                position: 'absolute',
                top: 96,
                left: 24,
                height: 568,
            } }, children),
        viewLockScreen && renderLockScreen(device)));
};
exports.default = PhoneComponent;
